import { render, staticRenderFns } from "./LabelProduct.vue?vue&type=template&id=02a99891&scoped=true"
import script from "./LabelProduct.vue?vue&type=script&lang=js"
export * from "./LabelProduct.vue?vue&type=script&lang=js"
import style0 from "./LabelProduct.vue?vue&type=style&index=0&id=02a99891&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a99891",
  null
  
)

export default component.exports